import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/takeUntil';
import { HelperService } from '../../services/helper/helper.service';
import { UiService } from '../../services/ui/ui.service';
import { UserService } from '../../services/user/user.service';

declare var $;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('myStudiesNav') public myStudiesNav: ElementRef;
  @ViewChild('assignmentNav') public assignmentNav: ElementRef;
  @ViewChild('contactsNav') public contactsNav: ElementRef;
  @ViewChild('coursesNav') public coursesNav: ElementRef;
  @ViewChild('createCourseNav') public createCourseNav: ElementRef;
  @ViewChild('assessmentNav') public assessmentNav: ElementRef;

  private _destroySubject = new Subject();

  public baseRoute: string;
  public showNavs = {
    myStudies: false,
    assignment: false,
    contacts: false,
    courses: false,
    createCourse: false,
    assessment: false,
  };
  public bookRequestCount = 0;

  public scrollbarOptions = {
    axis: 'y',
    theme: 'minimal',
    autoExpandScrollbar: true,
    // scrollbarPosition: 'outside',
    scrollInertia: 200,
    mouseWheel: { preventDefault: true },
  };

  constructor(
    public ui: UiService,
    public user: UserService,
    private http: HttpClient,
    public helper: HelperService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) {}

  @HostListener('window:resize')
  onWindowResize() {
    this.checkWindowSize();
  }

  ngOnInit() {
    this.checkWindowSize();
    this.getBookRequestCount();
    this.ui.event$.takeUntil(this._destroySubject).subscribe((res: any) => {
      if (res.name === 'UpdateBookRequestCount') {
        this.getBookRequestCount();
      }
    });
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   const checkNavOpenFn = (showNavsKey, element) => {
    //     const classList = element && element.nativeElement.classList;
    //     this.showNavs[showNavsKey] = (classList && classList.contains('show-child-nav')) || false;
    //   }

    //   const navElems = {
    //     myStudies: this.myStudiesNav,
    //     assignment: this.assignmentNav,
    //     contacts: this.contactsNav,
    //     courses: this.coursesNav,
    //     createCourse: this.createCourseNav,
    //     assessment: this.assessmentNav
    //   };

    //   Object.entries(navElems).forEach(item => checkNavOpenFn(item[0], item[1]));
    // }, 0);
    const navClick = $('.js-show-child-nav');
    const showChildNav = $('.js-open-nav');

    $(navClick).on('click', function (e) {
      e.preventDefault();
      // slideup siblings nav child menu if any open
      $(this).parent().siblings().find(showChildNav).slideUp(200);
      $(this).parent().siblings().find(navClick).removeClass('nav-open');
      // add class and slide down nav child menu when clicked
      $(this).toggleClass('nav-open');
      $(this).siblings(showChildNav).slideToggle(200);
    });
  }

  ngOnDestroy() {
    this._destroySubject.next(1);
    this._destroySubject.complete();
  }

  private checkWindowSize() {
    this.ui.showSidebar = window.innerWidth >= 991;
  }

  get isSuperAdmin() {
    return this.user.isSuperAdmin;
  }

  getBookRequestCount() {
    this.http
      .get('/book-request/count/all', {
        params: {
          ...(!this.user.isSuperAdmin
            ? { 'branch-id': this.user.userBranchId }
            : {}),
        },
      })
      .subscribe((res: number) => {
        this.bookRequestCount = res;
      });
  }
}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/sidebar/sidebar.component.ts